import FirstPickupApi from "../../../api/modules/FirstPickupApi";

export const searchPickups = async ({commit}, payload) => {
  try {
    const {context, ...data} = payload;
    const response = await FirstPickupApi.searchPickups(context, data);
    return response;
  } catch (error) {
    console.error("Error al buscar recojos:", error);
    throw error;
  }
};

export const changeStatusPickup = async ({commit}, payload) => {
  try {
    const response = await FirstPickupApi.changeStatusPickup(null, payload);
    return response;
  } catch (error) {
    console.error("Error al cambiar el estado del recojo:", error);
    throw error;
  }
};

export const downloadPickupOrderPdf = async ({commit}, payload) => {
  try {
    const {context, id} = payload;
    const response = await FirstPickupApi.downloadPickupOrderPdf(context, id);
    return response;
  } catch (error) {
    console.error("Error al descargar PDF de orden de recojo:", error);
    throw error;
  }
};

export const exportReport = async ({commit}, payload) => {
  try {
    const {context, ...data} = payload;
    const response = await FirstPickupApi.exportReport(context, data);
    return response;
  } catch (error) {
    console.error("Error al exportar el reporte de recojos:", error);
    throw error;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/firstPickup/actions.js